import en from 'antd-mobile/cjs/locales/en-US'
import es from 'antd-mobile/cjs/locales/es-ES'
import ar from './antd-mobile/ar'
import tr from './antd-mobile/tr'
import { getAntdLang, normalizeAppLang } from './lang'

export const antdLocales = {
  en,
  ar,
  tr,
  es
}

export function getAntdLocale(lang = 'en') {
  const antdLang = getAntdLang(normalizeAppLang(lang))
  return antdLocales[antdLang] ?? antdLocales.en
}
